const CopyHandler = {
  init(surah, btnCopyAyah) {
    this._copyListener({
      surah, btnCopyAyah,
    });
  },

  _copyListener({
    surah, btnCopyAyah,
  }) {
    btnCopyAyah.forEach((btn) => {
      const numAyahQuran = btn.getAttribute('numAyahQuran');
      const numAyahSurah = btn.getAttribute('numAyahSurah');
      const ayahNumber = btn.getAttribute('ayahNumber');
      const surahNumber = btn.getAttribute('surahNumber');
      const surahName = btn.getAttribute('surahName');
      const tooltipCopyAyah = document.querySelector(`#tooltip-copy-ayah-${numAyahQuran}`);
      const ayah = surah.data.ayahs[numAyahSurah - 1];
      const text = `
        ${ayah.arab}
        ${ayah.translation}
        (Q.S ${surahName} ${surahNumber}:${ayahNumber})
      `;
      btn.addEventListener('click', () => this._createCopy({
        text, tooltipCopyAyah,
      }));
    });
  },

  _createCopy({
    text, tooltipCopyAyah,
  }) {
    navigator.clipboard.writeText(text);
    tooltipCopyAyah.classList.remove('invisible');
    setTimeout(() => {
      tooltipCopyAyah.classList.add('invisible');
    }, 3000);
  },
};

export default CopyHandler;
